export const SortPriorityOrder = {
  Ongoing: 1,
  NotStarted: 2,
  Completed: 3,
};
